import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import Radio from "@material-ui/core/Radio";

import ClassAddBooking from "./ClassAddBooking";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 70;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const ClassAddOptions = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));



	const hasOptions = true;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const serviceOptions = [
		{
			bookingOption: "Free trial offer",
			detail: "New students only",
			price: "Free",
		},
		{
			bookingOption: "Drop-in",
			detail: "9 dates remaining • Packs available",
			price: "$25 / class",
		},
		{
			bookingOption: "Monthly pricing",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$65 / month",
		},
		{
			bookingOption: "Remaining schedule",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$250",
		},
		{
			bookingOption: "Full schedule",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$350",
		},
	];

	const [selectedOption, setSelectedOption] = useState(null);
	// const [selectedOption, setSelectedOption] = useState(
	// 	serviceOptions[0].bookingOption
	// );

	const handleRadioChange = (event) => {
		setSelectedOption(event.target.value);
	};

	// Close dialog

	const handleCloseClick = () => {
		onClose();
	};

	// ClassAddDetails

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const toggleDialog = () => {
		setIsDialogOpen(!isDialogOpen);
	};

	// ClassAddBooking

	const [isBookingDialogOpen, setIsBookingDialogOpen] = useState(false);

	const toggleBookingDialog = () => {
		setIsBookingDialogOpen(!isBookingDialogOpen);
	};

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			//maxWidth={"sm"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer2,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					<Box position={"absolute"} top={8} left={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<ArrowBackOutlinedIcon />
						</IconButton>
					</Box>
					{isElevated && (
						<Box
							fontSize={20}
							fontWeight={600}
							className={classes.serviceAddTitle}
							ml={8}
							mr={8}
						>
							Booking options
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				dividers={hasOptions}
				style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				{/* <Box
					fontWeight={600}
					fontSize={28}
					pb={4}
					maxWidth={"90%"}
					lineHeight={1.3}
				>
					Booking options
				</Box> */}
				<Box pb={4}>
					{hasOptions && (
						<>
							{/* <Box my={8}>
								<Divider light />
							</Box> */}
							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								mb={2}
							>
								<div>
									<Box fontSize={28} fontWeight={600} mb={1}>
										Select an option
									</Box>
									<Box color={"grey.600"} fontSize={15}>
										Choose one
									</Box>
								</div>

								<Box fontSize={14} fontWeight={600} color={"#ff5a52"}>
									2 spots left!
								</Box>
							</Box>
							<List>
								{serviceOptions.map((option, index) => (
									<ListItem
										key={index}
										button
										onClick={() => setSelectedOption(option.bookingOption)}
										classes={{
											root: classes.listItem,
											button: classes.listButton,
											container: classes.listItemContainer,
										}}
										disableGutters
									>
										<ListItemText
											classes={{
												primary: classes.listPrimary,
												secondary: classes.listSecondary,
												multiline: classes.listMultiline,
											}}
											primary={option.bookingOption}
											secondary={
												<>
													<Box mb={3}>{option.detail}</Box>
													<Box color={"#222 !important"} fontWeight={600}>
														{option.price}
													</Box>
												</>
											}
										/>
										<ListItemSecondaryAction>
											<Radio
												color="primary"
												edge="end"
												checked={selectedOption === option.bookingOption}
												onChange={handleRadioChange}
												value={option.bookingOption}
											/>
										</ListItemSecondaryAction>
									</ListItem>
								))}
							</List>
						</>
					)}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: 24 }}>
				<Box
					display={"flex"}
					flexDirection={"row"}
					justifyContent={"space-between"}
					width={"100%"}
					m={"0 auto"}
					maxWidth={600}
				>
					{/* <Box flexBasis={"48%"}>
						<Button
							fullWidth
							size={"large"}
							//onClick={declineOnClickHandler}
							variant="outlined"
							disableElevation
						>
							Cancel
						</Button>
					</Box> */}
					{/* <Box flexBasis={"48%"}> */}
					<Button
						fullWidth
						onClick={toggleBookingDialog}
						size={"large"}
						variant="contained"
						color="primary"
						disableElevation
						disabled={hasOptions ? !selectedOption : false}
					>
						Next
					</Button>

					<ClassAddBooking
						open={isBookingDialogOpen}
						onClose={toggleBookingDialog}
					/>
					{/* </Box> */}
				</Box>
			</DialogActions>
		</Dialog>
	);
};

ClassAddOptions.propTypes = {};
export default ClassAddOptions;
